export async function PanCardRegex(text) {
    const panCardRegex = /[A-Z]{5}[0-9]{4}[A-Z]{1}/;
    return panCardRegex.test(text)
}